
var ApsiyonAD = ApsiyonAD || {};


(function(app) {
    'use strict';

    app.ver  = '0.0.10';

    app.config = {

    };

    //general events
    app.events = {
        click : 'click',
        scroll: 'scroll',
        touch : 'touchstart',
        submit: 'submit'
    };

    //General selectors
    app.selectors = {
        slider      : '.slider-wrapper',
        sliderNav   : '.slider-navigation',
        sliderItem  : '.rotator-bullets li',
        flexBullets : '.flex-control-nav li',
        readmore    : '.read-more',
        mobilewrap  : '.mobile-visibility',
        contentText : '.content-text',
        mobileform  : '.content-form',
        showFormBtn : '.show-form',
        clickMask   : '.click-mask',
        form        : '.form',
        mobilePhone : '.mobile-phone'


    };

    app.$objs = {


    };

    app.classNames = {
        opened              : 'opened',
        active              : 'active',
        scrolled            : 'scrolled',
        loading             : 'loading',
        current             : 'current',
        mobilevisibility    : 'mobile-visibility'
    };

    //init functions
    app.init = function(){
        app.$objs.body = $('body');
        //$(app.selectors.slider).rotator({transition:'horizontal',bullets:true});
        $(app.selectors.slider).flexslider({
            animation: "slide",
            after:function(el){
                $(app.selectors.sliderItem).removeClass(app.classNames.current);
                $(app.selectors.sliderItem).eq(el.currentSlide).addClass(app.classNames.current);
            },
            controlsContainer: $(app.selectors.sliderNav)
        });

        app.globalEvents();
        app.mobileForm();
        app.formSubmit();
        app.numberInput();
    };

    app.globalEvents = function(){
        app.$objs.body.on(app.events.touch+' '+app.events.click,app.selectors.readmore,function(e){
            e.preventDefault();
            var $this = $(this),
                parent = $this.closest(app.selectors.contentText);
                parent.removeClass(app.classNames.mobilevisibility);

        }).on(app.events.click,app.selectors.sliderItem,function(){
            var $this = $(this);
            $(app.selectors.flexBullets).eq($this.index()).find('a').trigger(app.events.click);
        });
    };

    app.numberInput = function(){
        $(app.selectors.mobilePhone).mask('05999999999');

        $('input[type=tel]').keypress(function (e) {
            return event.charCode >= 48 && event.charCode <= 57;
        });
    };

    app.mobileForm = function(){
        app.$objs.body.on(app.events.touch+' '+app.events.click ,app.selectors.showFormBtn,function(){
            $(app.selectors.mobileform).addClass(app.classNames.active);
            app.$objs.body.append('<div class="click-mask"></div>');
        });

        app.$objs.body.on(app.events.touch+' '+app.events.click,app.selectors.clickMask,function(){
            $(app.selectors.mobileform).removeClass(app.classNames.active);
            $(app.selectors.clickMask).remove();
        });
    };

    app.formSubmit = function(){
        app.$objs.body.on(app.events.submit,app.selectors.form,function(){
            return app.validation(this);
        });
    };

    app.validation = function(form){
            var name = /^[a-zA-ZİışŞüÜğĞçÇöÖ]([-']?[a-zA-ZİışŞüÜğĞçÇöÖ]+)*( [a-zA-ZİışŞüÜğĞçÇöÖ]([-']?[a-zA-ZİışŞüÜğĞçÇöÖ]+)*)+$/,
                mail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/,
                number = /^[0-9]+$/;
            var allrequired = [];
            var errorTemplate = '<span role="alert" class="form-error">Lütfen Gerekli Alanı Doldurun</span>';
            var formInputs;

            var requiredInputs = function(boolarray){
                return boolarray.every(Boolean);
            };

            if(typeof form !== 'undefined'){
                formInputs = $(form).find(':input[required]');
            }else{
                formInputs = $(':input[required]:visible');
            }

            $.each(formInputs,function(i,item){
                $(item).parent().find('.form-error').remove();
                $(item).removeClass('error');
                if($(item).val() === '' || $(item).val() === null || $(item).val() === 'Seçiniz'){
                    allrequired.push(false);
                    $(item).addClass('error').parent().append(errorTemplate);
                }else if($(item).hasClass('name-input')){
                    if(name.test($(item).val())){
                        allrequired.push(true);
                    }else{
                        allrequired.push(false);
                        $(item).addClass('error').parent().append('<span role="alert" class="form-error">Lütfen Ad ve Soyadınızı giriniz</span>');

                    }
                }else if($(item).hasClass('mail-or-phone-input')){
                    if(mail.test($(item).val()) || number.test($(item).val())){
                        allrequired.push(true);
                    }else{
                        allrequired.push(false);
                        $(item).addClass('error').parent().append('<span role="alert" class="form-error">Lütfen geçerli bir E-mail ya da telefon numarası giriniz</span>');
                    }
                }else if($(item).attr('type') === 'email'){
                    if(mail.test($(item).val())){
                        allrequired.push(true);
                    }else{
                        allrequired.push(false);
                        $(item).addClass('error').parent().append('<span role="alert" class="form-error">Lütfen geçerli bir E-mail adresi giriniz.</span>');
                    }
                }else if($(item).attr('type') === 'number' || $(item).attr('type') === 'tel'){
                    if(number.test($(item).val())){
                        allrequired.push(true);
                    }else{
                        allrequired.push(false);
                        $(item).addClass('error').parent().append('<span role="alert" class="form-error">Lütfen sadece rakam giriniz.</span>');
                    }
                }
                else
                {
                    allrequired.push(true);
                }
            });

            return requiredInputs(allrequired);

    };


})(ApsiyonAD);

$(ApsiyonAD.init);
